import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { userDetailsService } from 'src/app/services/user.details.service';


@Component({
  selector: 'app-snapshot',
  templateUrl: './snapshot.component.html',
  styleUrls: ['./snapshot.component.scss']
})
export class SnapshotComponent implements AfterViewInit {

  WIDTH = 450;
  HEIGHT = 400;

  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;

  captures: string[] = [];
  error: any;
  isCaptured: boolean;
  localstream: any;
  buttonBorder: string = '';

  async ngAfterViewInit() {
    await this.setupDevices();
  }

  constructor(private userDetails: userDetailsService,private router: Router,private route: ActivatedRoute){}

  // ngOnInit() {
  //   const state = this.route?.snapshot?.root?.firstChild?.data?.state;
  //   if (state) {
  //     const value = state.value;
  //     // Use the id and name variables as needed in your dynamic component
  //     console.log('value***************:', value);
  //   }
  // }

  async setupDevices() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });
        if (stream) {
          this.localstream = stream.getTracks();
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          this.error = null;
        } else {
          this.error = "You have no output video device";
        }
      } catch (e) {
        this.error = e;
      }
    }
  }

  capture() {
    // this.buttonBorder = '0 0 5px 0 #000'; 
    this.drawImageToCanvas(this.video.nativeElement);
    if(this.captures.length >= 1)
    {
      this.captures.pop()
    }
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
    console.log("this.captures",this.captures)
    this.isCaptured = true;
  }

  async saveImage()
  {
    const userid = sessionStorage.getItem('id')
    const user = {
      userId : userid,
      imageURL: this.captures[0]
    }

    this.userDetails.updateImage(user).subscribe(
      (data) => {
                  this.video.nativeElement.pause();
                  this.video.nativeElement.srcObject = null;
                  this.localstream.stop();
                  // if (stream){
                  //   console.log("yessssssss")
                  //   stream.getTracks().forEach(track => {
                  //       console.log("track",track)
                  //       track.enabled = false
                  //         track.stop()});
                  // }
                  // stream = null
                  // console.log("stream",stream)
                  //       navigator.mediaDevices.getUserMedia({video: true, audio: false})
                  // .then(mediaStream => {
                  //   console.log("inside")
                  //   const stream = mediaStream;
                  //   const tracks = stream.getTracks();
                  //   stream.getTracks().forEach(track => {
                  //           console.log("track",track)
                  //           track.enabled = false
                  //             track.stop()});
                  // })
                })
               
      this.router.navigateByUrl('/instruction'); 
     
  }

  drawImageToCanvas(image: any) {
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }
}
